export enum LingoLiftProduct {
  LingoLift = 'lingolift',
  ListenWise = 'listenwise',
}
